export function getAllDaysInMonth(year: number, current_month: number, next_month: number, now: any) {
    const date = new Date(year, current_month, now.getDate());
    const date2 = new Date(year, next_month, 1);
    let daysInMonth = new Date(year, current_month, 0).getDate();
    const dates = [];

    while (date.getMonth() === current_month) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    if (now.getDate() <= daysInMonth) {
        for (let i = 0; i < daysInMonth - now.getDate() + 60; i++) {
            dates.push(new Date(date2))
            date2.setDate(date2.getDate() + 1);
        }
    }
    return dates;
}